import React from "react"
import DeleteFilter from "../../../../../assets/iconos/close.svg";
import { Menu, Dropdown, Icon, Select } from 'antd';
import { latest as API_URL } from "../../../../../config/api";
import axios from "axios";

const postUrlLogin  = API_URL + "widgets";

class ByDate extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            status_widget     : "inactive",
            current_key_time  : {},
            result_rows       : [],
            totals_widgets    : { reservations_ly_by_widget : 0, reservations_by_widget : 0 },
            interval_time_selected : {
                key : 'MONTH',
                value : '$month'
            }
        }
        this.getDefaultValues = this.getDefaultValues.bind(this);
    }
    getDefaultValues(){
        return {
            status_widget: "inactive",
            current_key_time: {},
            result_rows: [],
            totals_widgets: { reservations_ly_by_widget: 0, reservations_by_widget: 0 },
            interval_time_selected : {
                key : 'MONTH',
                value : '$month'
            }
        };
    }
    activeWdg(type){
        this.props.activeWidget(type)
    }
    handleTimeFilter(filt, segments, key, key_string) {
        let $self               = this;
        let current_key_time    = this.state.current_key_time;
        let widgetSegment       = this.props.widgetSegment;
        let type                = this.props.view_results !== "trimester" ? true : false;
        switch (type) {
            case true:
                let not_exist = (current_key_time[filt] === undefined) ? true : false;
                if(not_exist === true){
                    current_key_time[filt] = key
                }else if(not_exist === false){
                    delete current_key_time[filt]
                }

                const status  =  (Object.keys(current_key_time).length > 0) ? "active" : "inactive";

                if(status === "inactive"){
                    segments = null;
                }
                this.setState({
                    current_key_time : current_key_time,
                    status_widget : status
                }, function(){
                    $self.props.setSegments(segments, key, current_key_time);
                    $self.props.activeFiltersMS(status);
                });
                break;
        
            case false:
                const status_trimester  =  (Object.keys(current_key_time).length > 0) ? "active" : "inactive";
                this.setState({ 
                    status_widget : status
                }, () => $self.props.setTrimesters(status_trimester, key_string, key, filt))
                break;
        }
    }
    componentWillReceiveProps(props){
        let wdg     = props.statics;
        this.state.result_rows = Object.keys(wdg).map((filt, index) => {
            
            let cssStyle;

            //if(wdg[filt].num_reservations !== 0){
                if(props.layout._widgetSegmentPickup["major-segment-" + filt] !== undefined && props.layout._widgetSegmentPickup["major-segment-" + filt] !== null){
                    cssStyle = { height : (props.layout._widgetSegmentPickup["major-segment-" + filt].clientHeight) }
                }else{
                    cssStyle = wdg[filt].cssStyle;
                }

                const props_row = {
                    key : `list-bydate-${index}`,
                    className : `datagrid-item ${wdg[filt].state} ${(index%2 ? "row-c" : "")}`,
                    style : wdg[filt].state === "active" ? cssStyle : {}
                }
                const props_row_child = {
                    style : wdg[filt].state === "active" ? cssStyle : {}
                }
                const props_title = {
                    className : "title day " + ((props.is_history === true) ? "text-center" : ""), 
                    children : wdg[filt].string_value
                }
                const props_btn_more = {
                    onClick : this.handleTimeFilter.bind(this, filt, wdg[filt].segments, wdg[filt].key_value, wdg[filt].string_value),
                    className : `filter-row ${wdg[filt].state}`
                }
                
                
                return (
                    <div {...props_row}>
                        <div {...props_row_child}>
                            <span {...props_title}/>
                            {(props.is_history === false) ? <span {...props_btn_more} /> : "" }
                        </div>
                    </div>
                )
            //}
        })
    }

    setIntervalTimeView(interval){
        this.setState({
            interval_time_selected : interval,
        }, function(){

            let params = {
                pickup_module : {
                    interval_time_selected : this.state.interval_time_selected
                }
            }
           this.props.layout.callMainRequest(false, params);
        })
    }

    render = () => {
        let self = this;
        const Option = Select.Option;
        let pickup_years_future = self.props.layout.state.pickup_years_future
        const disabled_select = Object.keys(pickup_years_future).length > 1 ? false : true
        const listYearsSelect = Object.keys(pickup_years_future).map((index) =>
            <Option key={pickup_years_future[index]}>
                {pickup_years_future[index]}
            </Option>
        );    
        
        let select_years = (
            <Select
                showSearch={false}
                disabled={disabled_select}
                value={(self.props.app !== undefined) ? self.props.app.state.year_pickup_future : ""}
                size={'small'}
                style={{verticalAlign : 'middle', display : 'table-cell'}}
                onChange={ (value) => {
                    self.props.app.setState({
                        year_pickup_future : value
                    }, function(){
                        self.props.app.mainRequest();
                    })
                    
                }}
                children={listYearsSelect}
            />
        )
        const menu = (
            <Menu>
                <Menu.Item key="0" onClick={this.setIntervalTimeView.bind(this, { key : 'MONTH', value : '$month' })}>MONTH</Menu.Item>
                <Menu.Item key="1" onClick={this.setIntervalTimeView.bind(this, { key : 'WEEK', value : '$week' } )}>WEEK</Menu.Item>
                <Menu.Item key="3" onClick={this.setIntervalTimeView.bind(this, { key : 'DAY', value : '$dayOfWeek' })}>DAY</Menu.Item>
            </Menu>
        );
        return(<div className={"datagrid-widget by-date " + this.state.status_widget + " " + this.props.hidden_wdg_time + " " + this.props.view_results}>
            <div className={"container-fluid "}>
                <div className="row header-widget">
                    <div className="col-md-12 options-widget">
                        <span style={{color : "#FFFFFF"}} children={'MONTH'} />
                        {/*<Dropdown overlay={menu} trigger={['click']}>
                            <a className="ant-dropdown-link select-interval-period" href="#">
                                {this.state.interval_time_selected.key} <Icon type="down" />
                            </a>
                        </Dropdown>*/}
                    </div>
                </div>
                <div className="current-values">
                    <div className="row">
                        <div className="col-md-12 head-current">
                            {/* <span children={this.props.current_year} /> */}
                            {select_years}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 datagrid-list">
                            {this.state.result_rows}
                            <div className={"datagrid-month totals"}>
                                <div>TOTAL</div>
                            </div>
                        </div>
                    </div>
                </div>   
            </div>
        </div>)
    }
};

export default ByDate;



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/review/views/Pickup/ByDate.js